import { render } from "./BillView.vue?vue&type=template&id=9622627e"
import script from "./BillView.vue?vue&type=script&lang=js"
export * from "./BillView.vue?vue&type=script&lang=js"

import "./BillView.vue?vue&type=style&index=0&id=9622627e&lang=scss"
import "./BillView.vue?vue&type=style&index=1&id=9622627e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__